module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"mobileEmpty":"Enter your phone number"},"zh":{"mobileEmpty":"请输入手机号"},"mm":{"mobileEmpty":"ကျေးဇူးပြု၍ ဖုန်းနံပါတ်ရိုက်ထည့်ပေးပါ"}}')
  delete Component.options._Ctor
}
